// Strict, composable "mine" predicates.
export const isAssignedToUser = (task, userId) =>
  Array.isArray(task?.assigned_to) && task.assigned_to.includes(userId);

export const isCreatedByUser = (task, userId) => task?.user_id === userId;

// Personal-view scope: tasks the user is responsible for (assignee) OR
// created. Used by the inherently personal surfaces (Agenda, Planner, Inbox)
// where showing teammates' tasks would be noise. List views (Tasks page,
// project tables) do NOT use this - there the user filters explicitly via
// the table filter system and its "mine" presets.
export function filterMineTasks(tasks, userId) {
  if (!userId) return tasks;
  return (tasks || []).filter(
    (t) => isAssignedToUser(t, userId) || isCreatedByUser(t, userId),
  );
}

// Home's split of the same tasks. My work: assigned to me, or mine and given to nobody.
// Delegated: mine, given to others and not to me, so I am waiting on them (Home shows
// these only when asked). Together they are filterMineTasks.
const hasAssignee = (task) => Array.isArray(task?.assigned_to) && task.assigned_to.length > 0;

export const isMyWork = (task, userId) =>
  isAssignedToUser(task, userId) || (isCreatedByUser(task, userId) && !hasAssignee(task));

export const isDelegatedByUser = (task, userId) =>
  isCreatedByUser(task, userId) && hasAssignee(task) && !isAssignedToUser(task, userId);

const isOpen = (t) => t.status !== 'completed' && t.status !== 'archived' && !t.completed_at && !t.deleted_at;

// The Inbox: open, unscheduled tasks the person is responsible for, subtasks too (they
// are work like any other, lib/subtasks.js). The Inbox page, its badges and the desktop
// hive all count these.
export function inboxTasks(tasks, userId) {
  return filterMineTasks((tasks || []).filter((t) => isOpen(t) && !t.scheduled_start), userId);
}
